"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var react_router_1 = require("react-router");
var okta_react_1 = require("@okta/okta-react");
var config_1 = require("../../../config");
var AuthenticateLoader_1 = (0, tslib_1.__importDefault)(require("../AuthenticateLoader"));
var Authenticate = function () {
    var history = (0, react_router_1.useHistory)();
    var _a = (0, okta_react_1.useOktaAuth)(), oktaAuth = _a.oktaAuth, authState = _a.authState;
    var isAuthenticated = (authState !== null && authState !== void 0 ? authState : {}).isAuthenticated;
    var defaultPath = (0, config_1.useNTConfig)().MicroFE.defaultPath;
    (0, react_1.useEffect)(function () {
        var handleCallbackResponse = function () { return (0, tslib_1.__awaiter)(void 0, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!oktaAuth.isLoginRedirect()) return [3 /*break*/, 2];
                        return [4 /*yield*/, oktaAuth.handleLoginRedirect()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        if (!isAuthenticated) {
                            oktaAuth.signInWithRedirect();
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        handleCallbackResponse();
    }, [oktaAuth, isAuthenticated, defaultPath, history]);
    return react_1.default.createElement(AuthenticateLoader_1.default, { text: "Signing In..." });
};
exports.default = Authenticate;
